export default "__VITE_ASSET__e5253fd4__"